module.exports = __webpack_public_path__ + "8c94f4fd2e3e721d569981772c6ef93e.svg";